import type { SVGProps } from 'react';

const SvgBackground = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3H6C4.35 3 3 4.35 3 6v12c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3m-5.41 16H9.42l9.59-9.59v3.17zM5 11.41 11.41 5h3.17L5 14.59zM6 5h2.59L5 8.59V6c0-.55.45-1 1-1M5 18v-.59L17.41 5H18c.55 0 1 .45 1 1v.59L6.59 19H6c-.55 0-1-.45-1-1m13 1h-2.59L19 15.41V18c0 .55-.45 1-1 1"
    />
  </svg>
);
export default SvgBackground;
